import {StatusPill} from "@/components/statusPill/StatusPill.tsx";
import {PillStatus, StatusPillVariant} from "@/components/statusPill/StatusPill.types.ts";
import {MaintenanceSchedule, MaintenanceScheduleState} from "@/lib/types/maintenance.ts";
import {getScheduleState} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/MaintenanceSchedulesTable/MaintenanceSchedulesTable.utils.ts";

const MaintenanceScheduleStateMap: Record<MaintenanceScheduleState, PillStatus> = {
  [MaintenanceScheduleState.PAUSED]: PillStatus.PAUSED,
  [MaintenanceScheduleState.ACTIVE]: PillStatus.SCHEDULED,
  [MaintenanceScheduleState.IN_MAINTENANCE]: PillStatus.IN_MAINTENANCE,
  [MaintenanceScheduleState.ENDED]: PillStatus.ENDED,
};

interface MaintenanceSchedulesStatePillProps {
  schedule: MaintenanceSchedule;
  variant?: StatusPillVariant;
  className?: string;
}

export const MaintenanceSchedulesStatePill = ({
  schedule,
  variant = "textAndIcon",
  className,
}: MaintenanceSchedulesStatePillProps) => {
  const scheduleState = getScheduleState(schedule);
  return (
    <StatusPill
      type="checks"
      variant={variant}
      status={MaintenanceScheduleStateMap[scheduleState]}
      className={className}
    />
  );
};
